import { Location } from 'react-router-dom';

export function isPublicMatch(handle: unknown, location: Location) {
  if (typeof handle !== 'object' || handle == null || !('public' in handle))
    return false;

  if (handle.public === true) return true;
  if (typeof handle.public === 'function') return handle.public(location);
  return false;
}

export function isFullPageMatch(handle: unknown) {
  if (typeof handle !== 'object' || handle == null || !('fullPage' in handle))
    return false;

  if (handle.fullPage === true) return true;
  return false;
}
